import router from '@/router';
import axios from 'axios';
import { useUserStore } from '../store/user';
import { showErrorModal, showToastNonIntertConnection, showToastWarning } from '@/services/popups'; 

//const currentURL = "https://localhost:7249";
const currentURL = "https://backend.4lions.tec.br:7443";

const getInstance = () => {
    let instance = axios.create({
        baseURL: currentURL
    });                 
    
    instance.interceptors.request.use((config) => {            
        if (!window.navigator.onLine) { showToastNonIntertConnection(); }
        const userStore = useUserStore();
        const token = userStore.getUser.token;
        if (!token) {return config;}
        config.headers.Authorization = `Bearer ${token}`;                               
        return config;                
    });
    
    instance.interceptors.response.use((response) => {
        return response;
    }, (error) => {                          
        if (401 == error.response.status) {   
            localStorage.removeItem("user");
                                                   
            router.push("/login");    
    
            showToastWarning("Sessão Expirada");
        }               
        else {                    
            showErrorModal("Erro ao conectar-se ao servidor.");                    
        }
    });

    return instance;
}


export {
    getInstance  
} 

  





